export const sortableColumns = {
    version: 'version',
    formattedSize: 'formattedSize',
    uploadDate: 'uploadDate',
    expirationDate: 'expirationDate'
};
